import styled from 'styled-components';

export const HttpsText = styled.p`
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 24px;
  color: ${props => props.theme.interface5};
`;
